import React, { useMemo } from 'react';
import './index.scss';
import { useRouteMatch } from 'react-router-dom';

import { nl2br } from '../../utils/wordingSystem';
import { scrollToTop } from '../../utils/methods';
import { Facebook_Fill, Instagram, Youtube } from '../../components/Icons';

const Footer = ({ wording, common }) => {
  const matcher = useRouteMatch({ path: '/project' });
  const projectPageMatcher = useRouteMatch({ path: '/project' });
  const homePageMatcher = useRouteMatch({ path: '/' });

  const _w = wording, _c = common;

  const copyrightText = useMemo(() => {
    if (!_w) return;
    const text = _w.copyright;

    const thisYear = new Date().getFullYear();
    return text.replace("$year", thisYear);

  }, [_w]);

  return (
    <React.Fragment>
      {
        !(projectPageMatcher && projectPageMatcher.isExact === false) &&
        !(homePageMatcher && homePageMatcher.isExact) &&
        <div className="main-footer">
          <div className="container wrapper">
            <div className="footer">
              <div className="info">
                <div className="social">
                  <div className="list">
                    <a className="type-heading -en -h5" href={_c.facebook}><Facebook_Fill /></a>
                    <a className="type-heading -en -h5" href={_c.instagram}><Instagram /></a>
                    <a className="type-heading -en -h5" href={_c.youtube}><Youtube /></a>
                  </div>
                </div>
                <div className="contact">
                  <div className="type-text -en -md address">
                    <span>{_w.address}<span>&nbsp;{_w.address_en}</span>&emsp;</span>
                    <span>{_w.contact}</span>
                  </div>
                  <div className="type-text -en -md copyright">{copyrightText}</div>
                </div>
              </div>
            </div>
            <div className="scroll-to-top">
              <button onClick={scrollToTop}>
                <i className="icon-arrow-top"></i>
                <div className="type-text -en -lg">Back to top</div>
              </button>
            </div>
          </div>
        </div>
      }
    </React.Fragment>
  )
}

export default Footer;